import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]
  static values = { key: String }

  connect() {
    if (!this.hasKeyValue || !this.wasShared()) return

    this.reveal({ scroll: false })
  }

  show() {
    this.markShared()
    this.reveal({ scroll: true })
  }

  reveal({ scroll }) {
    if (!this.hasPanelTarget) return

    this.panelTarget.classList.remove("hidden")
    if (scroll) this.panelTarget.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }

  markShared() {
    if (!this.hasKeyValue) return

    try {
      window.localStorage.setItem(this.keyValue, "1")
    } catch {
      // The panel still appears for this visit if storage is unavailable.
    }
  }

  wasShared() {
    try {
      return window.localStorage.getItem(this.keyValue) === "1"
    } catch {
      return false
    }
  }
}
